import { createSlice } from '@reduxjs/toolkit';
import { createAgent, findAgents, updateAgent, deleteAgent } from './api';
import { initialState } from './api/interfaces';

const agentManagementSlice = createSlice({
    name: 'agentManagement',
    initialState,
    reducers: {
        setLimit: (state, action) => {
            state.limit = action.payload.limit;
            state.status = 'idle';
        },
        setSkip: (state, action) => {
            state.skip = action.payload.skip;
            state.status = 'idle';
        },
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload.currentPage;
        },
        removeAgentById: (state, action) => {
            state.data = state.data.filter((agent) => agent.id !== action.payload.id);
        },
        setStatus: (state, action) => {
            state.status = action.payload.status;
        },
        reset: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(findAgents.pending, (state) => {
                state.isLoading = true;
                state.status = 'pending';
            })
            .addCase(findAgents.fulfilled, (state, action) => {
                state.isLoading = false;
                state.status = 'idle';
                state.isSuccess = true;
                state.data = action.payload.data || [];
                state.totalRecords = action.payload.total || 0;
                state.skip = action.payload.skip || 0;
                state.limit = action.payload.limit || 10;
            })
            .addCase(findAgents.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.status = 'failed';
                state.errorMessage = action.payload as string;
            })
            .addCase(createAgent.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(createAgent.fulfilled, (state) => {
                state.isLoading = false;
                state.isSuccess = true;
            })
            .addCase(createAgent.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.errorMessage = action.payload as string;
            })
            .addCase(updateAgent.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(updateAgent.fulfilled, (state) => {
                state.isLoading = false;
                state.isSuccess = true;
            })
            .addCase(updateAgent.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.errorMessage = action.payload as string;
            })
            .addCase(deleteAgent.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(deleteAgent.fulfilled, (state) => {
                state.isLoading = false;
                state.isSuccess = true;
            })
            .addCase(deleteAgent.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.errorMessage = action.payload as string;
            });
    },
});

export const { setLimit, setSkip, setCurrentPage, removeAgentById, setStatus, reset } = agentManagementSlice.actions;
export default agentManagementSlice.reducer;

